import { render, staticRenderFns } from "./preferred-educator-queue.vue?vue&type=template&id=3363eb68&scoped=true&"
import script from "./preferred-educator-queue.vue?vue&type=script&lang=js&"
export * from "./preferred-educator-queue.vue?vue&type=script&lang=js&"
import style0 from "./preferred-educator-queue.vue?vue&type=style&index=0&id=3363eb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363eb68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard})
